import React from 'react';
import { motion } from 'framer-motion';
export function Results() {
  const metrics = [{
    value: '3.2x',
    label: 'Average increase in qualified pipeline from content',
    trend: '+220%'
  }, {
    value: '67%',
    label: 'Reduction in overall content production costs',
    trend: '-67%'
  }, {
    value: '142%',
    label: 'Average organic traffic growth in first 6 months',
    trend: '+142%'
  }, {
    value: '€2.4M',
    label: 'Average pipeline influenced per client annually',
    trend: 'Verified'
  }];
  return <section id="results" className="py-24 bg-navy-900 text-white relative overflow-hidden" data-id="element-165">
      {/* Infographic Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern-light opacity-[0.05] pointer-events-none" data-id="element-166"></div>
      <div className="absolute top-0 right-0 w-1/2 h-full border-l border-white/5 pointer-events-none hidden lg:block" data-id="element-167"></div>
      <div className="absolute top-1/2 left-0 w-full h-px border-t border-white/5 pointer-events-none hidden lg:block" data-id="element-168"></div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-169">
        <div className="text-center mb-20" data-id="element-170">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center gap-3 mb-6" data-id="element-171">
            <div className="w-2 h-2 bg-white rotate-45" data-id="element-172"></div>
            <span className="text-navy-300 font-medium uppercase tracking-wider text-sm" data-id="element-173">
              The Impact
            </span>
            <div className="w-2 h-2 bg-white rotate-45" data-id="element-174"></div>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-175">
            Metrics that matter to the board.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10" data-id="element-176">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 p-10 relative group overflow-hidden" data-id="element-177">
              {/* Hover Geometric Effect */}
              <div className="absolute -right-10 -top-10 w-32 h-32 bg-white/5 clip-hexagon opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-178"></div>

              <div className="mb-6 flex justify-between items-start" data-id="element-179">
                <div className="w-8 h-1 bg-navy-500" data-id="element-180"></div>
                <span className="font-mono text-xs text-navy-400 border border-navy-700 px-2 py-1" data-id="element-181">
                  {metric.trend}
                </span>
              </div>

              <div className="text-5xl md:text-6xl font-heading font-bold text-white mb-4 tracking-tight" data-id="element-182">
                {metric.value}
              </div>

              <p className="text-sm text-slate-400 leading-relaxed font-medium" data-id="element-183">
                {metric.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}